module.exports = __webpack_public_path__ + "img/6f_r_twodays_1@2x.d8e014ef.jpg";